import {useCallback} from "react";

import {PricesHubSectionName, trackPricesHubViewSection} from "../../tracking/track_prices_hub_view_section";
import {ViewSectionTracker} from "../ViewSectionTracker";

interface IProps {
    sectionName: PricesHubSectionName;
}

/** Renders nothing visible - drop it inside a section to report that section as seen, once per page view. */
export const PricesHubViewSectionTracker = (props: IProps) => {
    const {sectionName} = props;
    const handleVisible = useCallback(() => trackPricesHubViewSection(sectionName), [sectionName]);

    return <ViewSectionTracker id={sectionName} onVisible={handleVisible} />;
};
import {useCallback} from "react";

import {PricesHubSectionName, trackPricesHubViewSection} from "../../tracking/track_prices_hub_view_section";
import {ViewSectionTracker} from "../ViewSectionTracker";

interface IProps {
    sectionName: PricesHubSectionName;
}

/** Renders nothing visible - drop it inside a section to report that section as seen, once per page view. */
export const PricesHubViewSectionTracker = (props: IProps) => {
    const {sectionName} = props;
    const handleVisible = useCallback(() => trackPricesHubViewSection(sectionName), [sectionName]);

    return <ViewSectionTracker id={sectionName} onVisible={handleVisible} />;
};
